const settings = {
  ctrlSpeed: 0.4,
  quality: 2,
  maxZoom: 1000,
  minZoom: 0.4,
  maxPolarAngle: 4,
  minPolarAngle: 0,
  autoRotate: true,
  autoRotateSpeed: 5,
  cameraTweenSpeed: 1500,
  TargetTweenSpeed: 2000,
  voiceSpeed: 1,
  voicePitch: 1,
  voiceLevel: 1,
  developmentModel: false,
};

export default settings;
